import {
  TableDateRangeCell,
  TableDateCell,
  TableDateTimeCell,
  TableDateTimeNoYearCell,
  TableSelectionCell,
  TableFileCell,
  TableLinkCell,
  TableMechanicSelectionCell,
  TableObjectCell,
  TableSimpleValueCell,
  TableValueCellComponent,
  TableUnsupportedTypeCell,
  TableWarehouseItemsCell,
} from "./valueDisplayTableRenderers";

export const valueDisplayTableRegistry: Record<
  string,
  TableValueCellComponent
> = {
  text: TableSimpleValueCell,
  password: TableSimpleValueCell,
  textarea: TableSimpleValueCell,
  number: TableSimpleValueCell,
  calculation: TableSimpleValueCell,
  radio: TableSimpleValueCell,
  calculated: TableSimpleValueCell,
  status: TableSimpleValueCell,
  dateRangePicker: TableDateRangeCell,
  phone: TableLinkCell,
  email: TableLinkCell,
  url: TableLinkCell,
  collectionPicker: TableObjectCell,
  object: TableObjectCell,
  segmentedButtons: TableSelectionCell,
  dropdown: TableSelectionCell,
  datePicker: TableDateCell,
  dateTime: TableDateTimeCell,
  dateTimeNoYear: TableDateTimeNoYearCell,
  mechanicPicker: TableMechanicSelectionCell,
  testPicker: TableMechanicSelectionCell,
  warehouseItemsPicker: TableWarehouseItemsCell,
  file: TableFileCell,
  fileAndDocument: TableFileCell,
  document: TableFileCell,
};

export const getValueDisplayTableComponent = (
  fieldType: string,
): TableValueCellComponent => {
  return valueDisplayTableRegistry[fieldType] || TableUnsupportedTypeCell;
};
